<div class="modal-body">
    <div class="confirm">
        <h3 class="confirm__title">Unsaved changes</h3>
        <p class="confirm__text">Do you want to proceed without saving changes?</p>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="cancelClose()">CANCEL</button>
    <button type="button" class="btn btn-primary" (click)="closeModal()">CONFIRM</button>
</div>
